import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Departments from './components/Pages/Departments';
import CorporateCheckup from './components/Pages/CorporateCheckup';
import InternationalPatients from './components/Pages/InternationalPatients';
import { useEffect } from 'react';
import ErrorPage from './components/Pages/ErrorPage';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="departments" element={<Departments />} />
        <Route path="bilan-entreprise" element={<CorporateCheckup />} />
        <Route
          path="patients-internationaux"
          element={<InternationalPatients />}
        />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
